import {
  FETCH_SUPPORT_REQUEST,
  FETCH_SUPPORT_SUCCESS,
  FETCH_SUPPORT_FAILURE,
} from "../../redux/actions/supportAction"

const initialState = {
  loading: false,
  list: [],
  error: null,
}

const supportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUPPORT_REQUEST:
      return { ...state, loading: true, error: null }

    case FETCH_SUPPORT_SUCCESS:
      return { ...state, loading: false, list: action.payload }

    case FETCH_SUPPORT_FAILURE:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}

export default supportReducer
